import type { BookingConfirmationInsurance } from '@massilia/queries'

import { ExternalLink, Shield } from 'lucide-react'

import { centsToEuros, formatPrice } from '@/utils/format-price'

interface InsuranceSectionProps {
  insurance: BookingConfirmationInsurance
}

export function InsuranceSection({ insurance }: InsuranceSectionProps) {
  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-gray-light-200 bg-white p-6">
      <div className="text-lg leading-7 font-semibold text-gray-light-900 sm:text-2xl">
        Assurance voyage
      </div>

      <div className="flex flex-col gap-4 rounded-xl border border-gray-light-200 p-4">
        <div className="flex items-center gap-3">
          <div className="flex size-9 items-center justify-center rounded-lg bg-brand-50">
            <Shield className="size-5 text-brand-600" />
          </div>
          <div className="flex flex-col">
            {insurance.nomAssurance && (
              <span className="text-sm font-semibold text-gray-light-900">
                {insurance.nomAssurance}
              </span>
            )}
            {insurance.nomFormule && (
              <span className="text-xs font-medium text-gray-light-600">
                {insurance.nomFormule}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-start justify-between gap-3 text-sm">
          <span className="font-medium text-gray-light-700">Prix</span>
          <span className="font-semibold text-gray-light-900">
            {formatPrice(centsToEuros(insurance.price))}
          </span>
        </div>

        {insurance.dinLink && (
          <div className="flex flex-wrap gap-3">
            <a
              className="flex items-center gap-1 text-xs font-medium text-brand-600 hover:text-brand-700"
              href={insurance.dinLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              Documents d&apos;informations <ExternalLink className="size-3" />
            </a>
          </div>
        )}
      </div>
    </div>
  )
}
